import { ReactElement, useMemo } from 'react';
import { useLocale } from '@hooks/useLocale';
import { CompareTableInterface } from '@adapters/bigcommerce/types/compareTable';
import { CompareTableSlice } from '@adapters/prismic/types/brandedStorePage';
import mapCompareTableData from '@adapters/prismic/utils/mapCompareTableData';
import FranchiseCompareTable from '_components/Product/FranchiseCompareTable';
import ProductCompareTable from '_components/Product/ProductCompareTable';

import styles from './CompareTable.module.scss';

interface CompareTableProps {
  primary?: CompareTableSlice['primary'];
  table?: CompareTableInterface;
}

const CompareTable = ({
  primary,
  table,
}: CompareTableProps): ReactElement | null => {
  const locale = useLocale();
  const data = useMemo(
    () => mapCompareTableData(primary, table, locale),
    [primary, table, locale]
  );

  if (!data) return null;

  return (
    <div className={styles.root}>
      {data.kind === 'franchise' ? (
        <FranchiseCompareTable surface="category" config={data.config} />
      ) : (
        <ProductCompareTable surface="category" config={data.config} />
      )}
    </div>
  );
};

export default CompareTable;
